// extracted by mini-css-extract-plugin
export var button = "bY_qk";
export var button__darkBlue = "bY_qp";
export var button__edgesGrey = "bY_qq";
export var button__edgesRed = "bY_qm";
export var button__loader = "bY_qr";
export var button__red = "bY_ql";
export var button__transparent = "bY_qn";
export var loadingSpinner = "bY_qs";